import React from 'react';
import './Header.scss';


const Header = (props) => {
  return (
    <header>
      <a href="/" id="headerOut"></a><h1><a href="/">Pumpkin Carving Template Maker</a></h1>
      <div className="menu">{props.children}</div>
    </header>
    )
}

export default Header;
